// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__3wMAY","main":"style_main__rrEe5"};